import React from "react";

import disability_confident_badge from "../../assets/images/Certificates/DisabilityConfidentBadge.png";
import { CYBER_ESSENTIALS_EMBED } from "@/constants/landing";

const Certificates = () => {
  return (
    <div className="w-full h-auto px-4 mb-4">
      <div className="flex flex-col md:flex-row justify-center items-center gap-8">
        <div dangerouslySetInnerHTML={{ __html: CYBER_ESSENTIALS_EMBED }} />
        <img
          src={disability_confident_badge}
          alt="Disability Confident Badge"
          className="h-[100px] w-auto object-contain bg-white"
        />
      </div>
    </div>
  );
};
export default Certificates;
